<template lang="pug">
transition(name='el-fade-in')
    .box-card-inserir-dados-manual__conteudo__bloco
        .box-card-inserir-dados-manual__conteudo__bloco__elegibilidade.width-direito
            .cabecalho-resumo-elegibilidade
                .analise-elegibilidade-span
                    span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.analiseDeElegibilidade') }}
                    .analise-elegibilidade-span__resultado(
                        v-if='resultadoElegibilidade !== "INDEFINIDO"'
                    )
                        i.flow.flow-warning-sign(
                            :class='corStatus[resultadoElegibilidade].classeCor'
                        )
                        span(
                            :class='corStatus[resultadoElegibilidade].classeCor'
                        ) {{ corStatus[resultadoElegibilidade].status }}
                    .analise-elegibilidade-span__resultado(v-else) -

            #resumoDiv.resumo-elegibilidade(
                :style='{ "background-color": corStatus[resultadoElegibilidade]?.background || "" }'
            )
                .resumo-elegibilidade__diagnostico.resumo-elegibilidade-item
                    |
                    span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.diagnosticoSocioambiental') }}
                    SkeletonBlocoResumoAnalise.resumo-elegibilidade__diagnostico--item(
                        :carregando='loadingResumo'
                    )
                        span(
                            v-if='dadosAnaliseElegibilidade.dadosDiagnostico.resultadoDiagnosticoRastreabilidade === null'
                        )
                            | -
                        span(
                            v-else,
                            :class='statusDiagnostico[dadosAnaliseElegibilidade.dadosDiagnostico.nivelAlertaRastreabilidade].corClasse'
                        ) {{ this.statusDiagnostico[dadosAnaliseElegibilidade.dadosDiagnostico.nivelAlertaRastreabilidade].status }}

                .resumo-elegibilidade__diagnostico.resumo-elegibilidade-item(
                    v-if='this.usuarioLogado.ambienteLogado === "AR"'
                )
                    |
                    span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.saldoDisponivel') }}
                    SkeletonBlocoResumoAnalise.resumo-elegibilidade__diagnostico--item(
                        :carregando='loadingResumo'
                    )
                        span(
                            v-if='dadosAnaliseElegibilidade.dadosDiagnostico.saldoTerritorial === null'
                        )
                            | -
                        span(
                            v-else,
                            :class='this.formatNumber(dadosAnaliseElegibilidade.saldoTerritorial.saldoCapacidadeProdutiva) > 0 ? "status-sucess" : "status-danger"'
                        ) {{ this.formatNumber(dadosAnaliseElegibilidade.saldoTerritorial.saldoCapacidadeProdutiva) }}

                .resumo-elegibilidade__distancia.resumo-elegibilidade-item
                    |
                    span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.distancia') }}
                    SkeletonBlocoResumoAnalise.resumo-elegibilidade__distancia--item(
                        :carregando='loadingResumo'
                    )
                        span(
                            v-if='dadosAnaliseElegibilidade.dadosCalculoRaio.distanciaRaioLocalidade === null'
                        )
                            | -
                        span(
                            v-else,
                            :class='dadosAnaliseElegibilidade.dadosCalculoRaio.distanciaPermitida > 0 ? classAnaliseDistancia : "status-sucess"'
                        ) {{ dadosAnaliseElegibilidade.dadosCalculoRaio.distanciaRaioLocalidade }} km

                .resumo-elegibilidade__link-detalhar.resumo-elegibilidade-item(
                    v-if='dadosAnaliseElegibilidade.dadosDiagnostico.nivelAlertaRastreabilidade !== null',
                    @click.prevent='modalAnaliseElegibilidade'
                )
                    span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.verDetalhes') }}
                    i.mdi.mdi-arrow-right
                .resumo-elegibilidade__link-detalhar(v-else)

        .box-card-inserir-dados-manual__conteudo__bloco__volume
            el-form(
                label-position='top',
                :model='formularioCadastroTerritorio',
                :rules='formularioCadastroTerritorioRegrasVolume',
                ref='formularioCadastroTerritorioVolume',
                @submit.native.prevent
            )
                .box-card-inserir-dados-manual__conteudo__bloco_pesquisa-por-volume.width-esquerdo
                el-form-item(prop='volumeTerritorio')
                    template(slot='label')
                        span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.volume') }}

                    el-input(
                        :placeholder='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.inserirVolume")',
                        v-model='formularioCadastroTerritorio.volumeTerritorio',
                        @blur='$emit("volume-formatado")',
                        :disabled='loadingResumo'
                    )

        .box-card-inserir-dados-manual__conteudo__bloco__buttons.width-esquerdo
            el-button(
                type='primary',
                icon='el-icon-plus',
                :disabled='resultadoElegibilidade === "INDEFINIDO"',
                :loading='territorioSendoInserido',
                @click.prevent='$emit("validar-territorio-manual")'
            ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.adicionarLista') }}
</template>

<script>
import SkeletonBlocoResumoAnalise from '@/components/contratosOriginacao/SkeletonBlocoResumoAnaliseEligibilidade.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'BlocoResumoElegibilidade',
    components: {
        SkeletonBlocoResumoAnalise
    },

    props: {
        dadosAnaliseElegibilidade: {
            type: Object,
            required: true
        },
        resultadoElegibilidade: {
            type: String,
            required: true
        },
        formularioCadastroTerritorio: {
            type: Object,
            required: true
        },
        loadingResumo: {
            type: Boolean,
            default: false
        },
        territorioSendoInserido: {
            type: Boolean,
            default: false
        },
        mostrarCodigoCar: {
            type: Boolean,
            default: true
        }
    },

    data() {
        const validarVolume = (rule, value, callback) => {
            if (value === '') {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.campoObrigatorio'
                        )
                    )
                );
                return;
            }

            if (value.toString().includes('.')) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.somenteNumero'
                        )
                    )
                );
                return;
            }

            const maisVirgulas = /.*,.*,.*/;
            if (
                maisVirgulas.test(value) ||
                value.toString().startsWith(',') ||
                value.toString().startsWith(',')
            ) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.ErroFormatacao'
                        )
                    )
                );
                return;
            }

            if (parseFloat(value.toString().replace(',', '.')) <= 0) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.maiorQueZero'
                        )
                    )
                );
                return;
            }

            callback();
        };

        return {
            formularioCadastroTerritorioRegrasVolume: {
                volumeTerritorio: [
                    {
                        required: true,
                        validator: validarVolume,
                        trigger: 'blur'
                    }
                ]
            },
            corStatus: {
                ELEGIVEL: {
                    classeCor: 'status-sucess',
                    background: '#3591381A',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.elegivel'
                    )
                },
                INELEGIVEL: {
                    classeCor: 'status-danger',
                    background: '#EC32321A',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.inelegivel'
                    )
                },
                INDEFINIDO: {
                    classeCor: '',
                    status: ''
                },
                ALERTA: {
                    classeCor: 'status-laranja',
                    background: '#F9935A1A',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.comAlerta'
                    )
                }
            },
            statusDiagnostico: {
                MEDIO_ALTO: {
                    corClasse: 'status-laranja',
                    status: 'Alerta'
                },
                MEDIO: {
                    corClasse: 'status-amarelo',
                    status: 'Alerta'
                },
                BAIXO: {
                    corClasse: 'status-sucess',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.elegivel'
                    )
                },
                ALTO: {
                    corClasse: 'status-danger',
                    status: 'Inconforme'
                }
            }
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado']),

        classAnaliseDistancia() {
            return this.dadosAnaliseElegibilidade.dadosCalculoRaio
                .distanciaRaioLocalidade &&
                this.dadosAnaliseElegibilidade.dadosCalculoRaio
                    .distanciaRaioLocalidade >
                    this.dadosAnaliseElegibilidade.dadosCalculoRaio
                        .distanciaPermitida
                ? 'status-danger'
                : 'status-sucess';
        }
    },

    methods: {
        formatNumber(number) {
            const numericValue = parseFloat(number);
            return Number.isInteger(numericValue)
                ? numericValue.toString()
                : numericValue.toFixed(3);
        },

        modalAnaliseElegibilidade() {
            this.$emit('modal-analise-elegibilidade');
        }
    }
};
</script>

<style lang="scss" scoped>
.box-card-inserir-dados-manual__conteudo__bloco {
    margin-bottom: 15px;
    font-size: 16px;
    display: flex;
    gap: 15px;

    .width-direito {
        width: 68%;
    }

    .width-esquerdo {
        width: 22%;
    }

    .box-card-inserir-dados-manual__conteudo__bloco__buttons {
        display: flex;
        justify-content: flex-end;
        gap: 15px;
        margin-top: 39px;

        button.el-button.el-button--primary {
            width: 100%;
            height: 40px;
        }
    }

    .box-card-inserir-dados-manual__conteudo__bloco__elegibilidade {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 5px;

        .analise-elegibilidade-span {
            display: flex;
            gap: 5px;
            align-items: center;
        }

        span {
            font-weight: bold;
            color: var(--primary);
            font-size: 14px;
        }

        .status-amarelo {
            font-weight: bold;
            color: #bfae19;
            font-size: 14px;
            margin-left: 4px;
        }

        .status-laranja {
            font-weight: bold;
            color: var(--warning);
            font-size: 14px;
            margin-left: 4px;
        }

        .status-danger {
            font-weight: bold;
            color: var(--danger);
            font-size: 14px;
            margin-left: 4px;
        }

        .status-sucess {
            font-weight: bold;
            color: var(--green);
            font-size: 14px;
            margin-left: 4px;
        }

        .cabecalho-resumo-elegibilidade {
            display: flex;
            gap: 44px;
            align-items: center;

            .analise-elegibilidade-codigo-car {
                font-weight: bold;
                display: flex;
                gap: 5px;

                span.car-codigo {
                    font-weight: normal;
                    color: #303133;
                    font-size: 14px;
                }
            }
        }

        .resumo-elegibilidade {
            display: flex;
            justify-content: space-between;
            gap: 5px;
            align-items: center;
            flex-wrap: wrap;
            background-color: #e7e7e7;
            border-radius: 5px;
            padding: 8px 8px;
            min-height: 48px;

            .resumo-elegibilidade-item {
                display: flex;
                gap: 5px;
                align-items: center;
                min-height: 30px;
            }

            .resumo-elegibilidade__link-detalhar {
                min-width: 114px;

                span,
                i.mdi.mdi-arrow-right {
                    margin-left: 5px;
                    text-decoration: none;
                    color: #1989fa;
                    cursor: pointer;
                }
            }

            .resumo-elegibilidade__link-detalhar:hover {
                span,
                i.mdi.mdi-arrow-right {
                    text-decoration: underline;
                }
            }

            .resumo-elegibilidade__saldo--item {
                min-width: 120px;
            }

            .resumo-elegibilidade__diagnostico--item {
                min-width: 80px;
            }

            .resumo-elegibilidade__distancia--item {
                min-width: 100px;
            }
        }
    }
}
</style>
